<div class="paddings">
	<ng-content></ng-content>
</div>
